import http from '../helpers/http';

const AnnualReview = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    getByToken: async (employeeToken: string) => {
      const result = await http.get(`/annual-reviews/by-token/${employeeToken}`);
      return result.data;
    },
    submitEmployeeAnswers: async (employeeToken: string, body: { answers: any; isDraft?: boolean }) => {
      const result = await http.post(`/annual-reviews/by-token/${employeeToken}/employee-answers`, body);
      return result.data;
    },
    listPendingForMe: async (schoolId?: string) => {
      const query = schoolId ? `?schoolId=${schoolId}` : '';
      const result = await http.get(`/annual-reviews/pending-for-me${query}`, { headers });
      return result.data;
    },
    listFinishedForMe: async (schoolId?: string) => {
      const query = schoolId ? `?schoolId=${schoolId}` : '';
      const result = await http.get(`/annual-reviews/finished-for-me${query}`, { headers });
      return result.data;
    },
    listByUserId: async (userId: string) => {
      const result = await http.get(`/annual-reviews/by-user/${userId}`, { headers });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/annual-reviews/${id}`, { headers });
      return result.data;
    },
    getCurrentPayRate: async (id: string) => {
      const result = await http.get(`/annual-reviews/${id}/current-pay-rate`, { headers });
      return result.data;
    },
    submitSupervisorAnswers: async (id: string, body: { answers: any; isDraft?: boolean }) => {
      const result = await http.post(`/annual-reviews/${id}/supervisor-answers`, body, { headers });
      return result.data;
    },
    submitGrowthPlan: async (id: string, body: { growthPlan: any; proposedPayRate?: any }) => {
      const result = await http.post(`/annual-reviews/${id}/growth-plan`, body, { headers });
      return result.data;
    },
    uploadSignedPdf: async (id: string, formData: FormData) => {
      const result = await http.post(`/annual-reviews/${id}/signed-pdf`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      });
      return result.data;
    },
    cancel: async (id: string) => {
      const result = await http.delete(`/annual-reviews/${id}`, { headers });
      return result.data;
    },
    regenerateDraftPdf: async (id: string) => {
      const result = await http.post(`/annual-reviews/${id}/regenerate-draft-pdf`, {}, { headers });
      return result.data;
    },
    bindPayRate: async (id: string, payRateId: string) => {
      const result = await http.post(`/annual-reviews/${id}/bind-pay-rate`, { payRateId }, { headers });
      return result.data;
    },
    skipPayRate: async (id: string) => {
      const result = await http.post(`/annual-reviews/${id}/skip-pay-rate`, {}, { headers });
      return result.data;
    },
    triggerKickoff: async (employeeId: string, cycleYear?: number) => {
      const body = cycleYear ? { cycleYear } : {};
      const result = await http.post(`/annual-reviews/kickoff/${employeeId}`, body, { headers });
      return result.data;
    },
  };
};

export default AnnualReview;
